controllers.controller('UploadDocumentsFilesController', [
    '$scope', '$q', '$state', '$stateParams', 'LocaleService', 'constants', 'DocumentService',
    function ($scope, $q, $state, $stateParams, LocaleService, Const, DocumentService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });
        $scope.constants = Const;
        $scope.baseCategory = $stateParams.baseCategory;
        $scope.categoryVideoLink = $stateParams.categoryVideoLink;
        $scope.documents = DocumentService.documents;

        $scope.files = getDocumentsByBaseCategory($scope.baseCategory);
        $scope.category = $scope.files[0].category;

        var modalDefaults = {
            isError: false,
            textTitle: '',
            textContent: '',
            state: false,
            actionText: LocaleService.translation.try_again,
            back: ''
        };

        $scope.modal = angular.copy(modalDefaults);

        function getDocumentsByBaseCategory(category) {
            return $scope.documents
                .filter(function (document) {
                    return document.baseCategory === category;
                });
        }

        $scope.uploadFile = function (event) {
            var file = event.target.files[0];
            var documentType = event.target.attributes['file-id'].value;
            var message = '';
            var document = $scope.files.filter(function (doc) {
                return doc.type === documentType;
            }).shift();
            document.uploadStatus = 0;
            if (!file) {
                return; //exit if no file selected
            }

            if (!checkFileType(file.type)) {
                document.uploadStatus = -1;
                message = LocaleService.translation.file_incorrect_type;
                //console.log('invalid file type');
            }
            else if (!checkFileSize(file.size)) {
                document.uploadStatus = -2;
                message = LocaleService.translation.file_is_big_or_small;
                //console.log('file too big or small');
            }

            if (document.uploadStatus < 0) {
                $scope.modal.textTitle = LocaleService.translation.messages.Err600;
                $scope.modal.textContent = message;
                $scope.modal.isError = true;
                $scope.modal.state = true;
                return;
            } //exit if file is not validated

            return document.startUpload(file)
                .then(function (newFileName) {
                    return document.uploadFile(file, newFileName);
                })
                .then(function () {
                    //change document status
                    document.status = 'pending';
                })
                .catch(function (error) {
                    document.status = 'new';
                    document.uploadStatus = 0;
                    console.warn(error);
                    $scope.modal.textTitle = error && error.code && LocaleService.translation.messages[error.code] || LocaleService.translation.messages.Err600;
                    $scope.modal.textContent = error && error.code && error.code.toString().match(/^Err6\d\d$/) ? LocaleService.translation.messages.general_error_text : '';
                    $scope.modal.isError = true;
                    $scope.modal.state = true;
                })
        };

        function setCameraOptions(srcType) {
            return {
                quality: 50,
                destinationType: Camera.DestinationType.FILE_URI,
                srcType: srcType,
                encodingType: Camera.EncodingType.JPEG,
                mediaType: Camera.MediaType.PICTURE,
                allowEdit: true,
                correctOrientation: true
            };
        }

        $scope.takePhoto = function (document) {

            document.uploadStatus = 0;
            console.log(document);

            if (!navigator.hasOwnProperty('camera')) {
                return;
            }

            var options = setCameraOptions(Camera.PictureSourceType.CAMERA);

            return $q(function (resolve, reject) {
                function handleImage(image) {
                    resolve(image)
                }

                function handleError(error) {
                    reject(error);
                }

                navigator.camera.getPicture(handleImage, handleError, options);
            })
                .then(function (image) {
                    var file = {
                        name: '',
                        size: '',
                        type: ''
                    };
                    return document.startUpload(file)
                })
                .then(function (newFileName) {
                    return document.uploadFile(file, newFileName)
                })
                .then(function () {
                    //change document status
                    document.status = 'pending';
                })
                .catch(function (error) {
                    console.warn(error);
                })
        };

        function checkFileType(type) {
            return Const.fileTypes.filter(function (_type) {
                return _type === type;
            }).length > 0;
        }

        function checkFileSize(size) {
            return size >= Const.minFileSize && size <= Const.maxFileSize;
        }

        $scope.navigate = function (state, params) {
            return $state.go(state, {
                direction: params.direction,
                categoryName: params.category,
                categoryVideoLink: $scope.categoryVideoLink,
            });
        };
    }]);
